<div>
    <mat-dialog-actions>
        <Button mat-dialog-close style="margin-left: 90%;">
            <mat-icon>close</mat-icon>
        </Button>
    </mat-dialog-actions>
</div>
<div>
    <form [formGroup]="updateForm" (ngSubmit)="updateData()">
        <div class="form-row">
            <mat-form-field style="width: 80%; margin-top: 10%; margin-left: 10%" appearance="outline">
                <mat-label>Issue Name:</mat-label>
                <input type="text" matInput formControlName="issueName" />
            </mat-form-field>
        </div>
        <div class="form-row">
            <mat-form-field style="width: 80%; margin-top: 10px; margin-left: 10%" appearance="outline">
                <mat-label>Issue Date:</mat-label>
                <input type="date" matInput formControlName="issueDate" />
            </mat-form-field>
        </div>
        <div class="form-row">
            <mat-form-field style="width: 80%; margin-top: 10px; margin-left: 10%" appearance="outline">
                <mat-label>Published Date:</mat-label>
                <input type="date" matInput formControlName="PublishedDate" />
            </mat-form-field>
        </div>
        <div class="form-row">
            <mat-form-field style="width: 80%; margin-top: 10px; margin-left: 10%" appearance="outline">
                <mat-label>Price:</mat-label>
                <input type="number" matInput formControlName="price" />
            </mat-form-field>
        </div>
        <div class="form-row">
            <mat-form-field style="width: 80%; margin-top: 10px; margin-left: 10%" appearance="outline">
                <mat-label>Language:</mat-label>
                <input type="text" matInput formControlName="lang" />
            </mat-form-field>
        </div>
        <div class="form-group">
            <button style="margin-left: 35%;margin-top: 5%; width: 30%;" type="submit" mat-raised-button
                class="btn btn-info" [disabled]="updateForm.invalid">Update</button>
        </div>
    </form>
</div>